// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const BASE_DOMAIN = '0account.com';

// Every staging host is a PREFIX on the first label — `staging-v1`, `staging-my`,
// `staging-auth` — never `v1.staging`. Cloudflare's Universal SSL covers
// `0account.com` and `*.0account.com`, one level only, so a third-level name has
// no edge certificate and cannot be served at all. `staging.v1.0account.com`
// below was exactly that mistake, and it now does not resolve.
export const environment = {
  production: false,
  environment: 'staging',
  // Currently unreferenced (login handed off to the hosted auth page), but kept
  // correct: this is the `zero-staging` app row, not prod's `0account`.
  appId: '99d65052-cac8-4b47-8103-e01d0a2d4adc',
  ws_url: `wss://staging-v1.${BASE_DOMAIN}/ws`,
  site_url: `https://${BASE_DOMAIN}`,
  api_url: `https://staging-v1.${BASE_DOMAIN}`,
  // Prefix the API puts on its cookies; the CSRF one is read by the interceptor.
  // MUST equal the staging API's `prefix` config value. Staging gets its own
  // bucket so its cookies cannot collide with prod's on a shared parent domain —
  // leave this as '0account' and the interceptor reads a cookie the staging API
  // never sets, so every state-changing request 403s with nothing logged.
  cookie_prefix: 'staging0account',
  docs_url: `https://docs.${BASE_DOMAIN}`,
  portal_url: `https://staging-my.${BASE_DOMAIN}`,
  stripe_publishable_key:
    'pk_test_51H6j93LCNsiTHKzWgSQ3rHwtfRLAolTScoVdH2dmZX5NVKkby6Wzmgp15W3UeUy8WjL3in95mTgPTB8Mllfzw5Wp00OZD0x39f',
  sentry: {
    enabled: true,
    dsn: 'https://263af81fec37404e8fe79ce6c3cfc868@o942961.ingest.sentry.io/4504463661072384',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
